// src/pages/Workflows/index.js — Tela 1: Lista de Workflows

import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

import { useWorkflowsList } from './hooks/useWorkflowsList';
import WorkflowCard from './components/WorkflowCard';
import WorkflowFilters from './components/WorkflowFilters';
import ConfirmarEliminarModal from './components/ConfirmarEliminarModal';
import ExecutarModal from './components/ExecutarModal/ExecutarModal';

import './Workflows.css';

export default function Workflows() {
  const navigate = useNavigate();
  const { user } = useAuth();
  const isAdminUser = user?.isAdmin === true || user?.role === 'admin';

  const {
    workflows,
    loading,
    error,
    filtro, setFiltro,
    pesquisa, setPesquisa,
    workflowParaEliminar, setWorkflowParaEliminar,
    eliminando,
    eliminar,
  } = useWorkflowsList();

  const [workflowParaExecutar, setWorkflowParaExecutar] = useState(null);

  // Forçar filtro "partilhados" para utilizadores comuns
  useEffect(() => {
    if (!isAdminUser) setFiltro('partilhados');
  }, [isAdminUser]); // eslint-disable-line react-hooks/exhaustive-deps

  const handleEditar = (id) => navigate(`/workflows/${id}/editar`);
  const handleVerResultados = (id) => navigate(`/workflows/${id}/execucoes`);
  const handleNovoWorkflow = () => navigate('/workflows/novo');

  return (
    <div className="wf-lista-page">
      <div className="wf-lista-header">
        <div>
          <h1 className="wf-lista-title">Agentes JRRobot</h1>
          <p className="wf-lista-subtitle">Automatize processos jurídicos com agentes autônomos.</p>
        </div>
        {isAdminUser && (
          <button className="wf-btn wf-btn-primary" onClick={handleNovoWorkflow}>
            + Novo Workflow
          </button>
        )}
      </div>

      <WorkflowFilters
        filtro={filtro}
        setFiltro={setFiltro}
        pesquisa={pesquisa}
        setPesquisa={setPesquisa}
        isAdmin={isAdminUser}
      />

      {error && <div className="wf-error">{error}</div>}

      {loading ? (
        <div className="wf-loading">A carregar workflows...</div>
      ) : workflows.length === 0 ? (
        <div className="wf-empty">
          {pesquisa || filtro !== 'todos'
            ? 'Nenhum workflow encontrado com os filtros aplicados.'
            : 'Ainda não tem workflows. Crie o primeiro!'}
        </div>
      ) : (
        <div className="wf-cards-grid">
          {workflows.map(w => (
            <WorkflowCard
              key={w.id}
              workflow={w}
              onEditar={handleEditar}
              onExecutar={setWorkflowParaExecutar}
              onVerResultados={handleVerResultados}
              onEliminar={setWorkflowParaEliminar}
              isAdmin={isAdminUser}
            />
          ))}
        </div>
      )}

      <ConfirmarEliminarModal
        workflow={workflowParaEliminar}
        onConfirmar={eliminar}
        onCancelar={() => setWorkflowParaEliminar(null)}
        loading={eliminando}
      />

      {workflowParaExecutar && (
        <ExecutarModal
          workflow={workflowParaExecutar}
          onFechar={() => setWorkflowParaExecutar(null)}
          onConcluido={(execucaoId) => {
            setWorkflowParaExecutar(null);
            navigate(`/workflows/${workflowParaExecutar.id}/execucoes`);
          }}
        />
      )}
    </div>
  );
}
